import ResourceGroup from "core/resource/ResourceGroup";
export default class AudioResourceGroup extends ResourceGroup {
    constructor(name = 'default', audioModule = null, parent = ResourceGroup.default) {
        super(name, parent);
        this.audioModule = audioModule;
    }
}
